export default __webpack_public_path__ + "static/media/humanocity-stacked.ec4be71c.png";